export const ADD_CONTACT_US_DETAILS = "ADD_CONTACT_US_DETAILS";
export const ADD_CONTACT_US_DETAILS_BEGIN = "ADD_CONTACT_US_DETAILS_BEGIN";
export const ADD_CONTACT_US_DETAILS_SUCCESS = "ADD_CONTACT_US_DETAILS_SUCCESS";
export const ADD_CONTACT_US_DETAILS_FAIL = "ADD_CONTACT_US_DETAILS_FAIL";
export const GET_HISTORY_DETAILS = "GET_HISTORY_DETAILS";
export const GET_HISTORY_DETAILS_BEGIN = "GET_HISTORY_DETAILS_BEGIN";
export const GET_HISTORY_DETAILS_SUCCESS = "GET_HISTORY_DETAILS_SUCCESS";
export const GET_HISTORY_DETAILS_FAIL = "GET_HISTORY_DETAILS_FAIL";
